import { render, staticRenderFns } from "./PreviewConfigurationTextPanel.vue?vue&type=template&id=0b05a499&scoped=true"
import script from "./PreviewConfigurationTextPanel.vue?vue&type=script&lang=ts"
export * from "./PreviewConfigurationTextPanel.vue?vue&type=script&lang=ts"
import style0 from "./PreviewConfigurationTextPanel.vue?vue&type=style&index=0&id=0b05a499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05a499",
  null
  
)

export default component.exports